import { Text, TextProps, Tooltip, TooltipProps } from '@/design-system';
import { useTextClamped } from '@/hooks/useTextClamped';
import { cn } from '@/utils/tailwind';

export function TextOverflowTooltip({
  children,
  className,
  tooltipMaxWidth = 500,
  tooltipMaxHeight = 300,
  placement = 'bottom',
  align = 'center',
  customTooltip,
  textVariant,
  textProps = {},
}: {
  children: React.ReactNode;
  className?: string;
  tooltipMaxWidth?: number;
  tooltipMaxHeight?: number;
  placement?: TooltipProps['side'];
  align?: TooltipProps['align'];
  customTooltip?: React.ReactNode;
  textVariant?: TextProps['variant'];
  textProps?: Omit<TextProps, 'children'>;
}) {
  const { textRef, isTextClamped } = useTextClamped(children);

  return (
    <Tooltip
      title={
        <div
          className={`overflow-auto break-all`}
          style={{ maxWidth: tooltipMaxWidth, maxHeight: tooltipMaxHeight }}
        >
          {customTooltip
            ? customTooltip
            : typeof children === 'string'
            ? children
            : undefined}
        </div>
      }
      side={placement}
      align={align}
      disabled={!isTextClamped}
    >
      <Text
        ref={textRef}
        variant={textVariant}
        className={cn(
          // Only apply truncate if not using line-clamp classes
          !className?.includes('line-clamp') && 'truncate',
          className
        )}
        {...textProps}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
